import { useGetClockStatusQuery, useClockInMutation, useClockOutMutation } from "../api/apiSlice";

function formatTime(isoString) {
  const d = new Date(isoString);
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

export function useClock() {
  const { data, isSuccess } = useGetClockStatusQuery();
  const [clockInMutation] = useClockInMutation();
  const [clockOutMutation] = useClockOutMutation();

  const clockedInTime =
    isSuccess && data.clock_in_time && !data.clock_out_time
      ? formatTime(data.clock_in_time)
      : null;

  return {
    clockedInTime,
    handleClockIn: clockInMutation,
    handleClockOut: clockOutMutation,
  };
}
